import { PatrolGeneralInfo } from '../hooks/activePatrolHooks/useGeneralNotesInfo';

interface PatrolCompletionInfo {
	isComplete: boolean;
	isGeneralInfoComplete: boolean;
	incompleteChecklists: PatrolChecklist[];
}

export function getPatrolCompletionInfo(
	checklists: PatrolChecklist[],
	generalNotesInfo: PatrolGeneralInfo,
): PatrolCompletionInfo {
	const completionInfo: PatrolCompletionInfo = {
		isComplete: true,
		isGeneralInfoComplete: true,
		incompleteChecklists: [],
	};

	if (
		!generalNotesInfo.generalNotes.text ||
		!generalNotesInfo.generalStatus
	) {
		completionInfo.isComplete = false;
		completionInfo.isGeneralInfoComplete = false;
	}

	checklists.forEach((checklist) => {
		if (
			checklist.Checkpoints.some(
				(checkpoint) => checkpoint.CompletionStatus === 'Incomplete',
			)
		) {
			completionInfo.isComplete = false;
			completionInfo.incompleteChecklists.push(checklist);
		}
	});

	return completionInfo;
}
